// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'
import { QueryRegistryFactory } from '../../../contexts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const analyticsQueries: QueryRegistryFactory = (config) => {
  return {
    initCheckout: {
      type: 'mutation',
      query: gql`
          mutation initiateCheckout($cartId: String!) {
              initiateCheckout(
                  input: {
                      cart_id: $cartId
                  }
              )
          }
      `,
      meta: {
        noAuth: false
      }
    },
    trackPageContent: {
      type: 'mutation',
      query: gql`
          mutation trackPageContent($productId: Int!) {
              trackPageContent(product_id: $productId) {
                  success
                  message
              }
          }
      `,
      meta: {
        noAuth: false
      }
    },
    trackPageView: {
      type: 'mutation',
      query: gql`
          mutation trackPageView($url: String!) {
              trackPageView(url: $url) {
                  success
                  message
              }
          }
      `,
      meta: {
        noAuth: false
      }
    }
  }
}
